<div  [ngClass]="{ 'disabled': !isLanguageDateAndTimeSelected}"  class="dropdown" [class.show]="dropdownOpen">
  <p-button [disabled]="!isLanguageDateAndTimeSelected"
    class="w-full inline-flex cursor-pointer btn btn-secondary dropdown-toggle p-dropdown .p-dropdown-label p-component p-inputtext p-dropdown-clearable p-inputwrapper-filled"
    type="button"
    (click)="toggleDropdown()"
    [innerHTML]="dropdownLabel"
  />
  
  <p-card class="dropdown-menu absolute p-0" [class.show]="dropdownOpen">
    <div class="flex justify-content-between align-items-center priceLabelRow">
      <div class="details mr-4 text-left">
        {{basePrice?.title || 'Prezzo'}} <span class="text-xs text-gray-500">| {{formatCurrencyCents(basePrice?.price)}}</span>
      </div>
      <div class="flex justify-content-between align-items-center">
        <button type="button" class="quantityButton p-button p-component p-button-icon-only p-button-rounded p-button-outlined" (click)="decrementGlobal()">
          <i class="pi pi-minus"></i>
        </button>
        <span class="text-center quantityNumber">{{ numberOfPeople }}</span>
        <button type="button" class="quantityButton p-button p-component p-button-icon-only p-button-rounded p-button-outlined" (click)="incrementGlobal()">
          <i class="pi pi-plus"></i>
        </button>
      </div>
    </div>
  
    <div *ngFor="let price of extraPrices; let i = index" class="mt-3 priceLabelRow">
      <div class="flex justify-content-between align-items-center">
        <div class="details mr-4 text-left">
          {{price.title}} <span class="text-xs text-gray-500">| {{formatCurrencyCents(price.price)}}</span>
        </div>
        <div class="flex justify-content-between align-items-center">
          <button type="button" class="quantityButton p-button p-component p-button-icon-only p-button-rounded p-button-outlined" (click)="decrement(i)">
            <i class="pi pi-minus"></i>
          </button>
          <span class="text-center quantityNumber">{{ labelCounts[i] }}</span>
          <button type="button" class="quantityButton p-button p-component p-button-icon-only p-button-rounded p-button-outlined" (click)="increment(i)">
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </div>
    </div>
  
    <div class="flex mt-3">
      <span class="quantityRange">
        Minimo: {{ isReservation ? timePeopleInfo.minParties : experience?.details?.minPartiesToEnable}} -
        massimo: {{ isReservation ? (timePeopleInfo.maxParties - timePeopleInfo.occupiedCount) : experience?.details?.maxParties }} 
        <span class="quantityRange" *ngIf="isReservation"> - Occupanti: {{ timePeopleInfo.occupiedCount }}</span>
      </span>
    </div>
    <div class="mt-3">
      <strong>Totale:</strong> {{ formatTotalPrice() }}
    </div>
  </p-card>

</div>
